import Vue from 'vue'
import vLinkify from 'v-linkify'

Vue.use(vLinkify)
